import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  staging: false,
  development: true,
  apiUrl: 'https://dev-api.insightstobehavior.net/api',
  lmsUrl: 'https://dev-moodle.insightstobehavior.net',
  label: 'DEV',
  notificatioHubUrl: 'https://dev-api.insightstobehavior.net/notificationHub',
  secretKey: '725a0e9c-1286-411d-b598-5943a6308f0f',
  sentryDsn: 'https://82eb18254dbccdd95d7c04a1e6584e1a@sentry-insights.simformsolutions.com/161',
};
